<script>
  import { colors } from './colors.js'
  import { getContext } from 'svelte'
  import { formatThousands, formatDateLong } from './functions.js'
  import { scaleLinear, scaleTime } from 'd3-scale'
  import { extent, max } from 'd3-array'
  import { onMount } from 'svelte'
  import Axis from './components/Axis.svelte'
  import Line from './components/Line.svelte'
  import Area from './components/Area.svelte'
  import Grid from './components/Grid.svelte'

  let width
  let height = 300
  let latestVaccCount
  let latestDate
  let xScale
  let yScale
  let xTicks
  let yTicks

  onMount(async () => {
    addLineChart()
  })

  let { margin, nData } = getContext('chart')
  let nationalData = nData()

  $: xScale = scaleTime()
    .range([margin.left, width - margin.right])
    .domain(extent(nationalData, (d) => d.Date))

  $: yScale = scaleLinear()
    .range([height - margin.bottom, margin.top])
    .domain([0, max(nationalData, (d) => d.total_vaccinations)])

  $: xTicks = xScale.ticks(5)
  $: yTicks = yScale.ticks(5)

  function addLineChart() {
    latestVaccCount = nationalData[0].total_vaccinations
    latestDate = nationalData[0].Date
  }
</script>

<div class="chart-wrap">
  <div class="chart-title">Total Vaccinations In SA</div>
  <div class="chart-description">
    <div class="latest-number">{formatThousands(latestVaccCount)}</div>
    <div class="latest-date">{formatDateLong(latestDate)}</div>
  </div>
  <div class="chart chart-cumulative chart-block" bind:clientWidth={width}>
    <div class="annotation" style="right: {margin.right}px;">
      Total Vaccinations
    </div>
    <div
      class="annotation"
      style="right: {margin.right}px; top: {yScale(
        nationalData[0].Pfizer_total
      ) - 25}px;"
    >
      Total Pfizer
    </div>
    <div
      class="annotation"
      style="right: {margin.right}px; top: {yScale(
        nationalData[0].total_jandj
      ) - 25}px;"
    >
      Total J&J
    </div>

    <svg {height} {width}>
      <Area
        scale={{ x: xScale, y: yScale }}
        values={{ x: 'Date', y: 'total_vaccinations' }}
        {height}
        {width}
        data={nationalData}
        fill={colors['blue300']}
      />
      <Grid
        scale={{ x: xScale, y: yScale }}
        type="y"
        {width}
        ticks={{ x: xTicks, y: yTicks }}
      />
      <Line
        scale={{ x: xScale, y: yScale }}
        stroke={colors['blue700']}
        strokeWidth="3"
        values={{ x: 'Date', y: 'total_vaccinations' }}
        data={nationalData}
        {height}
        {width}
      />
      <!-- <Points
        scale={{ x: xScale, y: yScale }}
        values={{ x: 'Date', y: 'total_vaccinations' }}
        style={{
          fill: colors['red700'],
          radius: 3,
          stroke: 'none',
          strokeWidth: 0,
        }}
      /> -->

      <Line
        scale={{ x: xScale, y: yScale }}
        stroke={colors['red500']}
        strokeWidth="3"
        values={{ x: 'Date', y: 'Pfizer_total' }}
        data={nationalData}
        {height}
        {width}
      />

      <Line
        scale={{ x: xScale, y: yScale }}
        stroke={colors['red500']}
        strokeWidth="3"
        values={{ x: 'Date', y: 'total_jandj' }}
        data={nationalData}
        {height}
        {width}
      />

      <Axis
        type="x"
        ticks={{ x: xTicks, y: yTicks }}
        scale={{ x: xScale, y: yScale }}
        {height}
        {width}
      />
      <Axis
        type="y"
        ticks={{ x: xTicks, y: yTicks }}
        scale={{ x: xScale, y: yScale }}
        {height}
        {width}
      />
    </svg>
  </div>
</div>

<style>
  .chart {
    position: relative;
    font-family: 'Titillium Web', Arial, Helvetica, sans-serif;
    width: 100%;

    min-height: 250px;
    margin: 0 auto;
  }

  .latest-data {
    position: absolute;
    top: 50px;
    left: 50px;
    line-height: 100%;
    /* left: -10000px; */
  }
  .latest-number {
    font-weight: 700;
    font-size: 1rem;
    /* background: var(--darkgreen);
    color: #fff;
    padding: 4px 6px;
    font-size: 80%;
    border-radius: 5px; */
  }
  .latest-date {
    /* font-size: 70%;
    margin-top: 2px;
    margin-bottom: 3px; */
  }
</style>
